/* ============================================================
   [CLAUDE 2026-08-10] Floating quick-search button
   Trello #199 "When you scroll the page to the bottom user
   needs to scroll back to the top to be able to search"
   ------------------------------------------------------------
   MEASURED CAUSE (live theme, collection page):
     header.header--type-1   position: relative
   The header is NOT sticky, so once the customer scrolls the
   search field is gone and the only way back to it is to scroll
   all the way up.

   CORRECTION TO AN EARLIER DRAFT OF THIS FILE: it claimed the site
   has no back-to-top. It does. .scrollToTop is display:none only at
   scroll 0; once the page is scrolled it becomes display:block, a
   100x100 graphic at right:30px bottom:30px, z-index 19 (measured
   x 1775-1875, y 815-915 at 1920x945). So back-to-top is ALREADY
   SOLVED by the theme and is deliberately not duplicated here - an
   earlier build added an up-arrow and it landed on top of that
   graphic.

   FIX: one floating SEARCH button that fades in once the customer
   is more than 700px down. It returns to the top and focuses the
   existing header search input, or on mobile - where the header
   input is hidden - opens the nav popup and focuses #Search.
   No header markup is touched, so there is no risk of breaking
   the announcement bar or the nav.

   PLACEMENT: the bottom-right corner is crowded. Measured at
   1920x945 while scrolled:
     .scrollToTop            x 1775-1875, y 815-915  (theme)
     .widerruf-floating-btn  x 1726-1885, y 886-925
   This button sits ABOVE both at right:58px bottom:142px, which
   also centres it on the same vertical axis as the theme's
   back-to-top graphic (that graphic is 100px wide at right:30px,
   so its centre is right:80px; 80 - 44/2 = 58). z-index 999998,
   under any modal.

   CSS IS INJECTED FROM HERE ON PURPOSE. One file means the styles
   and the behaviour can never ship half-applied, and removing the
   feature is deleting a single <script> tag.

   ANIMATION NOTE: window.scrollTo({behavior:'smooth'}) is frozen
   when the page is not visible - measured earlier in this project:
   visibilityState "hidden" gave 0 requestAnimationFrame frames in
   500ms and scrollTop never moved. So scrolling here animates only
   when the page is visible and jumps instantly otherwise, and a
   timer guarantees the final position either way.

   TO REVERT: delete the <script> tag for this file from
   snippets/layout-get-includes-end.liquid.
   ============================================================ */
(function () {
  'use strict';
  try {
    var SHOW_AFTER = 700;
    var ID = 'claude-quick-nav';

    if (document.getElementById(ID)) return;

    var CSS = [
      '#' + ID + '{position:fixed;right:58px;bottom:142px;z-index:999998;',
      'display:flex;flex-direction:column;gap:10px;',
      'opacity:0;visibility:hidden;transform:translateY(8px);',
      'transition:opacity .22s ease,transform .22s ease,visibility .22s;}',
      '#' + ID + '.is-on{opacity:1;visibility:visible;transform:none;}',
      '#' + ID + ' button{width:44px;height:44px;padding:0;margin:0;',
      'display:flex;align-items:center;justify-content:center;',
      'border:1px solid rgba(53,78,87,.14);border-radius:50%;',
      'background-color:rgba(255,255,255,.94);',
      'box-shadow:0 2px 8px rgba(0,0,0,.18);cursor:pointer;',
      'transition:background-color .18s ease,box-shadow .18s ease;}',
      '#' + ID + ' button:hover{background-color:#fff;box-shadow:0 4px 14px rgba(0,0,0,.24);}',
      '#' + ID + ' button:focus-visible{outline:2px solid #354E57;outline-offset:2px;}',
      '#' + ID + ' svg{display:block;}',
      '@media (max-width:575px){#' + ID + '{right:16px;bottom:150px;}',
      '#' + ID + ' button{width:40px;height:40px;}}'
    ].join('');

    var ICON_SEARCH =
      '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<circle cx="10.5" cy="10.5" r="6.75" stroke="#354E57" stroke-width="2"/>' +
      '<path d="M15.6 15.6 20.5 20.5" stroke="#354E57" stroke-width="2" stroke-linecap="round"/></svg>';

    function toTop(done) {
      var start = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (start < 2) { if (done) done(); return; }

      var visible = (document.visibilityState || 'visible') === 'visible';
      if (!window.requestAnimationFrame || !visible) {
        window.scrollTo(0, 0);
        if (done) done();
        return;
      }

      var t0 = null, DUR = 320;
      requestAnimationFrame(function frame(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / DUR);
        var e = p < 0.5 ? 2 * p * p : -1 + (4 - 2 * p) * p;   /* easeInOutQuad */
        window.scrollTo(0, Math.round(start * (1 - e)));
        if (p < 1) requestAnimationFrame(frame);
      });

      /* land on 0 and hand over even if frames stop */
      setTimeout(function () { window.scrollTo(0, 0); if (done) done(); }, DUR + 120);
    }

    /* the header search input, only if it is actually on screen */
    function visibleSearchInput() {
      var all = document.querySelectorAll('input[name="q"]');
      for (var i = 0; i < all.length; i++) {
        var r = all[i].getBoundingClientRect();
        if (r.width > 20 && r.height > 5) return all[i];
      }
      return null;
    }

    function openSearch() {
      toTop(function () {
        var input = visibleSearchInput();
        if (input) { try { input.focus(); } catch (e) {} return; }
        /* header input hidden (mobile): open the nav popup, then focus its field */
        var trigger = document.querySelector('.js-popup-button[data-js-popup-button="navigation"]');
        if (trigger) {
          try { trigger.click(); } catch (e) {}
          setTimeout(function () {
            var f = document.getElementById('Search') || visibleSearchInput();
            if (f) { try { f.focus(); } catch (e) {} }
          }, 320);
        }
      });
    }

    function build() {
      if (document.getElementById(ID)) return;
      if (!document.body) return;

      var style = document.createElement('style');
      style.setAttribute('data-claude', 'quick-nav');
      style.appendChild(document.createTextNode(CSS));
      document.head.appendChild(style);

      var box = document.createElement('div');
      box.id = ID;

      var search = document.createElement('button');
      search.type = 'button';
      search.setAttribute('aria-label', 'Search');
      search.innerHTML = ICON_SEARCH;
      search.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation(); openSearch();
      });

      box.appendChild(search);
      document.body.appendChild(box);

      var on = false;
      function sync() {
        var y = window.pageYOffset || document.documentElement.scrollTop || 0;
        var want = y > SHOW_AFTER;
        if (want === on) return;
        on = want;
        box.classList.toggle('is-on', want);
      }
      window.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);

      /* A poll as well as the scroll listener, on purpose. Scroll events are not
         dispatched while the page is hidden - measured here: scrolling to y=1400
         left the control at opacity 0 with the is-on class never applied, while
         the buttons themselves worked fine. Two property reads twice a second is
         nothing next to this page's script load, and it makes the visible/hidden
         state deterministic instead of depending on an event that may not fire. */
      setInterval(sync, 500);

      sync();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', build);
    } else {
      build();
    }
  } catch (e) { /* never break the page */ }
})();
